<header class="header">
  <!-- Top Bar -->
  <div class="top-bar">
    <div class="container">
      <!-- Left Side -->
      <div class="top-bar__left">
        <div class="topics desktop-only">
          <span>Secciones:</span>
          <div class="sections-links">
            <a href="#" (click)="$event.preventDefault(); navigateToSection('latest-news', false)">ACTUALIDAD</a>
            <a href="#" (click)="$event.preventDefault(); navigateToSection('politics', false)">POLITICA</a>
            <a href="#" (click)="$event.preventDefault(); navigateToSection('economy', false)">ECONOMIA</a>
            <a href="#" (click)="$event.preventDefault(); navigateToSection('sports', false)">DEPORTES</a>
            <a href="#" (click)="$event.preventDefault(); navigateToSection('world', false)">MUNDO</a>
          </div>
        </div>
        <div class="mobile-only">
          <button class="sections-button" (click)="toggleMenu()">
            <i class="bi bi-list"></i>
            Secciones
          </button>
        </div>
      </div>

      <!-- Right Side -->
      <div class="top-bar__right">
        <div class="social-icons desktop-only">
          <a href="#"><i class="bi bi-instagram"></i></a>
          <a href="#"><i class="bi bi-facebook"></i></a>
          <a href="#"><i class="bi bi-twitter-x"></i></a>
          <a href="#"><i class="bi bi-youtube"></i></a>
          <a href="#"><i class="bi bi-linkedin"></i></a>
        </div>
        <div class="mobile-weather mobile-only">
          <ng-container *ngIf="!isLoadingWeather; else loadingWeather">
            <span class="weather" *ngIf="weather.temp !== null">Capital Federal
              <img *ngIf="weather.icon" [src]="'https://openweathermap.org/img/w/' + weather.icon + '.png'"
                [alt]="weather.description">
              {{weather.temp}}°
            </span>
          </ng-container>
          <ng-template #loadingWeather>
            <span class="weather">
              <i class="bi bi-thermometer-half"></i>
              Cargando...
            </span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Header -->
  <div class="main-header">
    <div class="container">
      <!-- Location and Weather -->
      <div class="location-weather">
        <div class="location-temp">
          <span class="location">Capital Federal</span>
          <ng-container *ngIf="!isLoadingWeather; else loadingWeather">
            <span class="weather" *ngIf="weather.temp !== null">
              <img *ngIf="weather.icon" [src]="'https://openweathermap.org/img/w/' + weather.icon + '.png'"
                [alt]="weather.description">
              {{weather.temp}}°
            </span>
          </ng-container>
          <ng-template #loadingWeather>
            <span class="weather">
              <i class="bi bi-thermometer-half"></i>
              Cargando...
            </span>
          </ng-template>
        </div>
        <span class="date">{{currentDate | date:'EEEE d \'de\' MMMM \'de\' yyyy':'':'es'}}</span>
      </div>

      <!-- Logo -->
      <div class="logo">
        <a href="/" class="logo-text" style="text-decoration: none;">
          <img src="../../../assets/images/borde-general.png" alt="Logo" style="height: 70px;">
        </a>
      </div>

      <!-- Auth Buttons -->
      <div class="auth-buttons">
        <a href="#" class="btn-login">Iniciar Sesión</a>
        <a href="#" class="btn-register">Registrarse</a>
      </div>
    </div>
  </div>
  <!-- Currency Bar -->
  <div class="currency-bar">
    <div class="container">
      <div class="currency-list">
        <!-- Solapa de Deuda Externa (izquierda) -->
        <div class="currency-item currency-debt" (click)="openDebtModal()" [title]="'Ver gráfico (' + (debtSourceLabel || 'INDEC') + ')'">
          <ng-container *ngIf="!isLoadingDebt; else loadingDebt">
            <span class="currency-label">Deuda externa AR</span>
            <span class="currency-update" *ngIf="debtLastUpdate"></span>
            <span class="currency-value" *ngIf="debtSourceValue !== null">· {{debtSourceValue | number:'1.0-0'}} M USD<span *ngIf="debtSourceDate"></span></span>
            <span class="currency-value" *ngIf="debtSourceValue === null">N/D</span>
          </ng-container>
          <ng-template #loadingDebt>
            <span class="currency-label">Deuda externa AR</span>
            <span class="currency-value">Cargando...</span>
          </ng-template>
        </div>
        <ng-container *ngIf="!isLoadingRates; else loadingRates">
          <div class="currency-item" *ngIf="dolarRates['oficial']">
            <span class="currency-label">Dólar oficial</span>
            <span class="currency-value">${{dolarRates['oficial'].venta | number:'1.2-2'}}</span>
          </div>
          <div class="currency-item" *ngIf="dolarRates['blue']">
            <span class="currency-label">Dólar blue</span>
            <span class="currency-value">${{dolarRates['blue'].venta | number:'1.2-2'}}</span>
          </div>
          <div class="currency-item" *ngIf="dolarRates['turista']">
            <span class="currency-label">Dólar turista</span>
            <span class="currency-value">${{dolarRates['turista'].venta | number:'1.2-2'}}</span>
          </div>
          <div class="currency-item" *ngIf="dolarRates['contadoconliqui']">
            <span class="currency-label">Dólar CCL</span>
            <span class="currency-value">${{dolarRates['contadoconliqui'].venta | number:'1.2-2'}}</span>
          </div>
          <div class="currency-item" *ngIf="dolarRates['bolsa']">
            <span class="currency-label">Dólar MEP</span>
            <span class="currency-value">${{dolarRates['bolsa'].venta | number:'1.2-2'}}</span>
          </div>
        </ng-container>
        <ng-template #loadingRates>
          <div class="currency-item">
            <span class="currency-label">Cargando cotizaciones...</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="navbar" [ngClass]="{'show': isMenuOpen}">
    <div class="container">
      <div class="navbar-collapse" [ngClass]="{'show': isMenuOpen}">
        <button class="close-menu" (click)="toggleMenu()">
          <i class="bi bi-x-lg"></i>
        </button>
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('latest-news', true)">ACTUALIDAD</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('politics', true)">POLITICA</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('economy', true)">ECONOMIA</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('sports', true)">DEPORTES</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('world', true)">MUNDO</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToSection('weather', true)">Tiempo en Capital Federal</a>
          </li>
        </ul>
        <div class="mobile-social-icons mobile-only">
          <a href="#"><i class="bi bi-instagram"></i></a>
          <a href="#"><i class="bi bi-facebook"></i></a>
          <a href="#"><i class="bi bi-twitter-x"></i></a>
          <a href="#"><i class="bi bi-youtube"></i></a>
          <a href="#"><i class="bi bi-linkedin"></i></a>
        </div>
      </div>
    </div>
  </nav>
</header>